import { Theme } from '@mui/material';
import { gridClasses } from '@mui/x-data-grid-pro';

export const getRecoScorePageStyles = (theme: Theme) => ({
  recoScoreContainer: {
    height: '100%',
    width: '100%',
    padding: 2,
  },
  
  dataGrid: {
    boxShadow: 2,
    borderRadius: 0,
    '& .MuiIconButton-root' : {
      color: theme.palette.text.primary,
    },
    '& .MuiSelect-icon' : {
      color: theme.palette.text.primary,
    },  
    [`& .${gridClasses.cell}`] : {
      color: theme.palette.text.secondary,
    },
    '& .MuiDataGrid-columnSeparator' : {
      color: theme.palette.divider,
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 'bold',
      color: theme.palette.text.secondary,
    },
    // Edited row styling
    [`& .${gridClasses.row}.row--edited`]: {
      backgroundColor: theme.palette.warning.light + '40 !important',
      '&:hover': {
        backgroundColor: theme.palette.warning.light + '60 !important',
      },
    },
    // Invalid row styling
    [`& .${gridClasses.row}.row--invalid`]: {
      backgroundColor: theme.palette.error.light + '20 !important',
      '&:hover': {
        backgroundColor: theme.palette.error.light + '40 !important',
      },
    },
    // Fix for pinned columns not getting row-level styling
    [`& .${gridClasses.row}.row--edited .MuiDataGrid-cell`]: {
      backgroundColor: theme.palette.warning.light + '40 !important',
    },
    [`& .${gridClasses.row}.row--invalid .MuiDataGrid-cell`]: {
      backgroundColor: theme.palette.error.light + '20 !important',
    },
  },
  
  errorContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
    color: theme.palette.text.secondary,
  },
  
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    color: theme.palette.text.secondary,
  },
});
